import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BreadcrumbModule } from '../breadcrumb';

import { RibbonHeadingBaseComponent } from './heading-section-components/ribbon-heading-base.component';
import { RibbonHeadingExtendedComponent } from './heading-section-components/ribbon-heading-extended.component';
import { RibbonAccordionComponent } from './ribbon-accordion.component';
import { RibbonSmartComponent } from './ribbon-smart.component';
import { RibbonComponent } from './ribbon.component';

@NgModule({
  declarations: [
    RibbonComponent,
    RibbonSmartComponent,
    RibbonAccordionComponent,
    RibbonHeadingBaseComponent,
    RibbonHeadingExtendedComponent
  ],
  imports: [CommonModule, BreadcrumbModule],
  exports: [
    RibbonComponent,
    RibbonSmartComponent,
    RibbonAccordionComponent,
    RibbonHeadingBaseComponent,
    RibbonHeadingExtendedComponent
  ]
})
export class RibbonModule {}

export * from './ribbon-accordion.component';
export * from './ribbon.component';
export * from './ribbon-smart.component';
export * from './heading-section-components/ribbon-heading-base.component';
export * from './heading-section-components/ribbon-heading-extended.component';
